/**
 * Created by OBL on 14/01/2016.
 */
define('superAdminMbSmpMatsController',[
    'module',
    'underscore',
    'app',
    'superAdminMbSmpMatsView',
    'bootbox',
    'mbSmpMatCreateEditLayoutView',
    'settings',
    'entities/mbsmpmats'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var SuperAdminMbSmpMatListController = {
        showMbSmpMatList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'mbsmpmat:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showMbSmpMatAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                mbsmpmatModel: App.request('mbsmpmat:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('mbsmpmat.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('mbsmpmat:get-collection-url'),
                rowCountUrl: App.request('mbsmpmat:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('mbsmpmat.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('mbsmpmat:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = SuperAdminMbSmpMatListController;
});
